var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      pad: "0",
      title: _vm.$t("label_essweb_BlockLeaveRecord_list_title"),
      filterable: "",
    },
    on: {
      filter: function (val) {
        _vm.filterPageData = val
      },
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(filter)
                },
                update: function (prop, value, selected) {
                  if (prop == "department") {
                    _vm.curDept = value
                  } //触发岗位更新下拉
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-card",
              {
                staticClass: "transparent d-flex flex-row rounded-lg",
                attrs: { elevation: "0" },
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "fill-height white rounded-lg pa-0",
                    style: {
                      minHeight:
                        _vm.$vuetify.breakpoint.height - 238 + 42 - 48 + "px",
                    },
                    attrs: { elevation: "0", width: "280" },
                  },
                  [
                    _vm.show_Staff.length == 0 && !_vm.staff_Loading
                      ? _c("noContent")
                      : _vm._e(),
                    _vm.staff_Loading
                      ? _c(
                          "v-sheet",
                          {
                            staticClass:
                              "text-center d-flex align-center justify-center",
                            style: {
                              minHeight:
                                _vm.$vuetify.breakpoint.height -
                                238 +
                                42 -
                                48 +
                                "px",
                            },
                          },
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                color: "primary",
                                size: "30",
                                width: "2",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.staff_Loading
                      ? _c(
                          "v-list",
                          {
                            staticClass: "scroll_content_y",
                            style: {
                              maxHeight:
                                _vm.$vuetify.breakpoint.height -
                                238 +
                                42 -
                                48 +
                                "px",
                            },
                            attrs: { dense: "" },
                          },
                          [
                            _c(
                              "v-list-item-group",
                              {
                                attrs: { color: "primary" },
                                model: {
                                  value: _vm.selectOneStaff,
                                  callback: function ($$v) {
                                    _vm.selectOneStaff = $$v
                                  },
                                  expression: "selectOneStaff",
                                },
                              },
                              _vm._l(_vm.show_Staff, function (staff, index) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: "staff---" + index,
                                    staticClass: "pa-0 px-2 ma-0",
                                    attrs: {
                                      dense: "",
                                      "two-line": "",
                                      value: staff.staff_id,
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-avatar",
                                      {
                                        staticClass: "pa-0 ma-0 mr-2",
                                        attrs: { size: "36" },
                                      },
                                      [
                                        _c("StaffAvatar", {
                                          attrs: {
                                            size: "36",
                                            isTemp: staff.is_temp,
                                            src: staff.staff_avatar,
                                            staff_name: staff.preferred_name,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "text-body-2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    staff.preferred_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text--secondary text-caption-xs",
                                              },
                                              [_vm._v(_vm._s(staff.staff_code))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "text-body-2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    staff.job_post_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "v-card",
                  {
                    staticClass: "ml-3 rounded-lg flex-grow-1",
                    style: {
                      maxWidth: "calc(100% - 292px)",
                    },
                    attrs: { elevation: "0" },
                  },
                  [
                    _c("Tabler", {
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.desserts,
                        "list-type": "client",
                        "config-head-key": "leave_balance_default_display",
                        height: _vm.$vuetify.breakpoint.height - 275 - 48,
                        totalCount: _vm.totalCount,
                      },
                      on: {
                        change: function (page, perpage, callback) {
                          _vm.getList(page, perpage, callback)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }